import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import ConstructionPage from './pages/ConstructionPage';
import LeisurePage from './pages/LeisurePage';
import HealthcarePage from './pages/HealthcarePage';
import CGIStagingPage from './pages/CGIStagingPage';

// SEO Landing Pages
import MatterportVirtualToursPage from './pages/MatterportVirtualToursPage';
import PointCloudSurveysPage from './pages/PointCloudSurveysPage';
import ScanToBimPage from './pages/ScanToBimPage';
import CommercialPropertyToursPage from './pages/CommercialPropertyToursPage';
import MatterportServiceProviderPage from './pages/MatterportServiceProviderPage';
import PricingPage from './pages/PricingPage';

// Blog Pages
import BlogIndexPage from './pages/blog/BlogIndexPage';
import WhatIsDigitalTwinPage from './pages/blog/WhatIsDigitalTwinPage';
import MatterportScanCostPage from './pages/blog/MatterportScanCostPage';
import ThreeDScanningNHSPage from './pages/blog/ThreeDScanningNHSPage';
import DroneSurveysCostUKPage from './pages/blog/DroneSurveysCostUKPage';
import BIMLevel2Page from './pages/blog/BIMLevel2Page';
import MatterportForArchitectsPage from './pages/blog/MatterportForArchitectsPage';
import VirtualTourCommercialPropertyPage from './pages/blog/VirtualTourCommercialPropertyPage';
import MatterportVsLaserScanningPage from './pages/blog/MatterportVsLaserScanningPage';

import { Toaster } from './components/ui/sonner';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Core pages */}
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<HomePage />} />
          <Route path="/construction" element={<ConstructionPage />} />
          <Route path="/leisure" element={<LeisurePage />} />
          <Route path="/healthcare" element={<HealthcarePage />} />
          <Route path="/hologram" element={<HomePage />} />
          <Route path="/cgi" element={<CGIStagingPage />} />
          <Route path="/contact" element={<HomePage />} />

          {/* SEO Landing Pages */}
          <Route path="/matterport-virtual-tours-london" element={<MatterportVirtualToursPage />} />
          <Route path="/point-cloud-surveys-london" element={<PointCloudSurveysPage />} />
          <Route path="/scan-to-bim-london" element={<ScanToBimPage />} />
          <Route path="/commercial-property-3d-tours-london" element={<CommercialPropertyToursPage />} />
          <Route path="/matterport-service-provider-uk" element={<MatterportServiceProviderPage />} />
          <Route path="/pricing" element={<PricingPage />} />

          {/* Blog */}
          <Route path="/blog" element={<BlogIndexPage />} />
          <Route path="/blog/what-is-a-digital-twin" element={<WhatIsDigitalTwinPage />} />
          <Route path="/blog/how-much-does-matterport-scan-cost-uk" element={<MatterportScanCostPage />} />
          <Route path="/blog/3d-scanning-nhs-hospitals" element={<ThreeDScanningNHSPage />} />
          <Route path="/blog/drone-survey-costs-uk" element={<DroneSurveysCostUKPage />} />
          <Route path="/blog/bim-level-2-requirements-uk" element={<BIMLevel2Page />} />
          <Route path="/blog/matterport-for-architects" element={<MatterportForArchitectsPage />} />
          <Route path="/blog/virtual-tours-commercial-property" element={<VirtualTourCommercialPropertyPage />} />
          <Route path="/blog/matterport-vs-laser-scanning-which-do-you-need" element={<MatterportVsLaserScanningPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
